import { pluralize } from './strings';

export const objectTotal = (
    obj?: Partial<Record<string, number | undefined | null>>
) => {
    return Object.values(obj || {}).reduce(
        (sum: number, value) => sum + (value || 0),
        0
    );
};

export const formatMapCount = (
    value: Record<string, number>,
    separator = ' '
) =>
    Object.keys(value)
        .map(name => name.toLowerCase())
        .filter(name => value[name])
        .map(name => pluralize(name, value[name]))
        .join(separator);
